import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RequestStatus, REQUEST_STATUSES } from 'commons/types/common';
import { Doctor } from 'commons/types/doctorsTypes';
import type { RootState } from 'stores/store';
import { getDoctor } from './doctorsClient';

export interface DoctorsState {
  current?: Doctor;
  currentRequestStatus?: RequestStatus;
}

const initialState: DoctorsState = {};

export const getDoctorAsync = createAsyncThunk(
  'doctors/getCurrent',
  (doctorID: string) => getDoctor(doctorID),
);

export const doctorsSlice = createSlice({
  name: 'doctors',
  initialState,
  reducers: {
    resetCurrentDoctor: (state) => {
      delete state.current;
      delete state.currentRequestStatus;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDoctorAsync.pending, (state) => {
        state.currentRequestStatus = REQUEST_STATUSES.PENDING;
      })
      .addCase(getDoctorAsync.fulfilled, (state, { payload }) => {
        state.currentRequestStatus = REQUEST_STATUSES.SUCCESS;
        state.current = payload;
      })
      .addCase(getDoctorAsync.rejected, (state) => {
        state.currentRequestStatus = REQUEST_STATUSES.ERROR;
      });
  },
});

export const { resetCurrentDoctor } = doctorsSlice.actions;

export const getCurrentDoctor = (state: RootState) => state.doctors.current;

export const getCurrentDoctorRequestStatus = (state: RootState) =>
  state.doctors.currentRequestStatus;
export default doctorsSlice.reducer;
